import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-remove",
  "use": "icon-remove-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-remove\"><defs><style type=\"text/css\"></style></defs><path d=\"M197.05558203 911.20333994l-76.31505791-76.31505791L836.23421885 119.39458643l76.31505878 76.31505878z\" p-id=\"1406\" /><path d=\"M836.23601797 911.20244082L120.74232237 195.70874521l76.31505878-76.31505791 715.4936956 715.49369473z\" p-id=\"1407\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol